/**
 * Executive Brief Service (BRIEFS-1)
 * AIDLC Administrative Backend
 *
 * The Executive Briefs library: HTML briefs agents write for the CEO.
 * Lists carry metadata only; the document is fetched on its own when a brief is opened.
 */

import apiClient from './api';

export interface ExecutiveBriefMeta {
  id: string;
  title: string;
  author: string;
  authorName: string;
  project: string;
  backlogItemId: string | null;
  summary: string;
  version: number;
  createdAt: string;
  updatedAt: string;
}

/** A brief document can be up to 2 MB; give it longer than the client's usual 15 s. */
const BRIEF_HTML_TIMEOUT_MS = 60000;

export async function fetchBriefs(): Promise<ExecutiveBriefMeta[]> {
  const response = await apiClient.get<ExecutiveBriefMeta[]>('/briefs');
  return response.data;
}

/**
 * The brief's HTML, fetched with the signed-in client: the portal's API takes a bearer token in a header,
 * which an iframe `src` cannot carry, so the page shows it through `srcdoc` instead.
 */
export async function fetchBriefHtml(id: string): Promise<string> {
  const response = await apiClient.get<string>(`/briefs/${encodeURIComponent(id)}/html`, {
    responseType: 'text',
    transformResponse: [(data: string) => data],
    timeout: BRIEF_HTML_TIMEOUT_MS,
  });
  return response.data;
}
